import React from "react";
import ReactDOM from "react-dom/client";
import ShopDashboard from "./ShopDashboard";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ShopDashboard />);
